import {
  TemplateLayoutTypeEnum,
  type Template,
  type TemplatePage,
} from '@ulysses-inc/harami_api_client'
import type { MigratedTemplateBody } from './types'

const migratedNamePrefix = '[移行後]'
const maxTemplateNameLength = 255

export const buildMigratedTemplateBody = ({
  sourceTemplateId,
  template,
  pages,
}: {
  sourceTemplateId: number
  template: Template
  pages: TemplatePage[]
}): MigratedTemplateBody => {
  // 旧表形式に固有の設定を持ち込まないよう、移行後も使う設定だけを選んで引き継ぐ。
  const inheritedTemplateSettings = {
    isShowScore: template.isShowScore,
    isEditable: template.isEditable,
    isHideQuestionOptions: template.isHideQuestionOptions,
    isAudit: template.isAudit,
    isKeyboard: template.isKeyboard,
  }

  return {
    gridToTableMigration: { sourceTemplateId },
    template: {
      ...inheritedTemplateSettings,
      name: `${migratedNamePrefix}${[...template.name]
        .slice(0, maxTemplateNameLength - [...migratedNamePrefix].length)
        .join('')}`,
      isExcelConversion: false,
      layoutType: TemplateLayoutTypeEnum.Scroll,
      hasVariables: false,
      manuals: [],
      icons: structuredClone(template.icons ?? []),
      placeNodes: structuredClone(template.placeNodes ?? []),
      approvalFlows: (template.approvalFlows ?? []).flatMap(flow =>
        flow.id === undefined ? [] : [{ id: flow.id }],
      ),
      multipleChoiceSets: (template.multipleChoiceSets ?? []).flatMap(set =>
        set.uuid ? [{ uuid: set.uuid }] : [],
      ),
    },
    pages,
    hints: [],
  }
}
